import { utils } from "@deltasge/marauders-map";
import React, { FC, Suspense, useEffect, useState } from "react";
import { getError, loadS3File } from "utils";
import ReactPlayer from "react-player";
import { snack } from "components/GlobalSnackbar";
import { Box, LinearProgress } from "@mui/material";

export const ChatVideo: FC<{ src: string }> = ({ src: init }) => {
  const [src, setSrc] = useState<string>();

  useEffect(() => {
    let ativo = true;
    (async () => {
      try {
        let finalUrl = init;
        if (
          init &&
          init.indexOf("https") == -1 &&
          !utils.isBase64(init, { allowMime: true })
        ) {
          const { error, processed } = await loadS3File(init);
          if (processed) finalUrl = processed;
          else if (error) {
            throw new Error(error);
          }
        }
        if (ReactPlayer && ReactPlayer.canPlay) {
          const result = ReactPlayer.canPlay(finalUrl);
          if (!result) {
            throw new Error("Este vídeo não pode ser tocado");
          }
        }
        if (ativo) setSrc(finalUrl);
      } catch (error) {
        snack.error(getError(error));
      }
    })();
    return () => {
      ativo = false;
    };
  }, []);

  return (
    <Box sx={{ width: "100%", overflow: "hidden" }}>
      <Suspense fallback={<LinearProgress />}>
        <ReactPlayer
          src={src}
          controls
          style={{ width: "100%", height: "auto", aspectRatio: "16/9" }}
        />
      </Suspense>
    </Box>
  );
};
